// Adding a locale here also needs its moment locale data imported in
// client/src/javascript/index.tsx - moment only preloads "en".
export const LOCALES = ["cs", "en"];
export const DEFAULT_LOCALE = "cs";
